import { Season } from '#types/generated/graphql-types';
import TabScroll from '#components/navigation/tabs/tabsScroll/TabScroll';
import SeasonTabItem from '#modules/series-details/SeasonTabItems';

type Props = {
  items: Season[];
  hideSeasonNumbers: boolean;
  classes?: string;
  selectedId?: number;
  onChange?: (seasonId: number) => void;
};

const SeasonSwitch = ({
  items,
  hideSeasonNumbers,
  onChange,
  selectedId,
  classes,
}: Props) => {
  return (
    <TabScroll classes={classes} isStyleButton={true}>
      {items.map((item) => (
        <SeasonTabItem
          key={item.id}
          item={item}
          hideSeasonNumbers={hideSeasonNumbers}
          isSeasonTabSelected={selectedId === item.id}
          onSeasonTabClick={() => onChange?.(item.id)}
        />
      ))}
    </TabScroll>
  );
};

export default SeasonSwitch;
